<template>
    <v-menu
            offset-y
            transition="slide-y-transition"
            bottom
    >
        <v-btn icon slot="activator">
            <v-badge overlap color="secondary" v-if="notificaciones.length > 0">
                <span slot="badge" class="text--primary">{{ notificaciones.length }}</span>
                <v-icon>
                    notifications
                </v-icon>
            </v-badge>
            <v-icon v-if="notificaciones.length == 0">notifications</v-icon>
        </v-btn>
        <v-list>
            <v-list-tile v-if="notificaciones.length > 0" v-for="(item, i) in notificaciones" :key="i" @click="readNotification(item)">
                <v-list-tile-title>{{ item.data.text }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="notificaciones.length == 0">
                <v-list-tile-title>No hay ninguna notificación</v-list-tile-title>
            </v-list-tile>
            <v-divider v-if="notificaciones.length > 0"></v-divider>
            <v-list-tile v-if="notificaciones.length > 0" @click="readAll()">
                <v-list-tile-title class="text-xs-center">Mark all as read</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>


</template>

<script>
    export default {
        data: () => ({
            notificaciones: []
        }),
        computed : {

        },
        created () {
            this.getNotificaciones();
            setInterval(() => {
                this.getNotificaciones();
            }, 60000)
        },
        methods :  {
            getNotificaciones() {
                this.$store.dispatch('getUserNotifications', {}).then((res) => {

                    this.notificaciones = res.data;

                }).catch((error) => {
                });
            },
            readNotification (item) {
                this.$store.dispatch('readUserNotifications', item).then((res) => {

                    this.getNotificaciones();

                    this.$router.push({ path: item.data.link })

                }).catch((error) => {
                });
            },
            readAll() {
                this.$store.dispatch('readUserAllNotifications', {}).then((res) => {

                    this.getNotificaciones();

                }).catch((error) => {
                });
            }
        },
        components : {
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/components/NotificationComponent.vue